import React from 'react';
import { Link } from '@saucelabs/ds-link';
import { IconInformationOutline } from '@saucelabs/ds-icons';
import { Tooltip } from '@saucelabs/ds-tooltip';
import { Typography } from '@saucelabs/ds-typography';
import { InputLabel } from '@saucelabs/ds-inputs';

const NoActiveTunnels: React.FC = () => (
  <div
    aria-label="No Active Tunnels"
    className="text-gray-600"
  >
    <div className="flex items-center">
      <InputLabel>
        Tunnel Proxies
      </InputLabel>

      <Tooltip
        placement="top"
        title="Allows you to test your app on localhost or behind a firewall"
      >
        <div className="flex items-center ml-0.75">
          <IconInformationOutline
            className="fill-current"
            height={14}
            width={14}
          />
        </div>
      </Tooltip>
    </div>

    <div className="h-5 flex items-center mt-0.5 px-1.5 bg-gray-100 border border-gray-400 border-solid rounded">
      <Typography className="inline">No Active Tunnels,&nbsp;</Typography>

      <Link to="/tunnels">set up a tunnel</Link>
    </div>
  </div>
);

export default NoActiveTunnels;
